import React from "react";
import RenderOddsHome from "./RenderOddsHome";
import moment from "moment";
import { formatWithCommas } from "../../../Utils/Toast";
import { Link } from "react-router-dom";

const SingleEvent = ({ res, matchOdds, addToFavioute }) => {
  function isDateToday(date) {
    return moment(date).isSame(moment(), "day");
  }
  return (
    <dl
      id="highLightEvent_34917695"
      className="game-list-col "
      // disabled
      style={{ display: "flex" }}
    >
      <dt id="eventInfo" style={{ cursor: "pointer" }}>
        <img
          id="playIcon"
          className={res?.status == "in_play" ? "icon-in_play" : "icon-no_play"}
          src="/assets/images/transparent.gif"

        />
        <Link
          to={`/match-detail-sky/${res?.eventId}/${res?.marketId}`}
          id="vsName"
        >
          {res?.eventName}
        </Link>
        <span id="dateTimeInfo" className="game-list-time">
          {res?.status == "in_play" ? (
            <span className="in_play">In-Play</span>
          ) : (
            `${
              isDateToday(res?.eventDateTime)
                ? "Today"
                : moment(res?.eventDateTime).format("DD/MM")
            } ${moment(res?.eventDateTime).format("HH:MM")}`
          )}
        </span>{" "}
        {res?.status == "in_play" && (
          <span
            className="game-live"
            id="streamingIcon"
            style={{
              display: "inline-flex",
              marginRight: "4px",
            }}
          >
            Live
          </span>
        )}
        {res?.hasFancy && (
          <span
            className="game-fancy in-play"
            id="fancyBetIcon"
            style={{
              cursor: "pointer",
              display: "inline-flex",
              marginRight: "4px",
            }}
          >
            Fancy
          </span>
        )}
        {res?.hasBookmaker && (
          <span
            className="game-bookmaker"
            id="bookMakerIcon"
            style={{ cursor: "pointer", marginRight: "4px" }}
          >
            BookMaker
          </span>
        )}
        {res?.hasSportBook && (
          <span
            className="game-sportsbook"
            id="feedingSiteIcon"
            style={{ marginRight: "4px" }}
          >
            Sportsbook
          </span>
        )}
      </dt>
      <dd id="matched" className="col-matched">
        BDT {formatWithCommas(res?.totalMatched)}
      </dd>

      <RenderOddsHome res={res} matchOdds={matchOdds} />

      <dd
        onClick={(e) => {
          if (res?.runners?.length > 0) {
            e.preventDefault();
            e.stopPropagation();
            addToFavioute(
              res?.eventId,
              "Match Odds",
              res?.marketId,
              res?.eventType,
              "Match Odds"
            );
          }
        }}
        className="col-info"
      >
        <a
          id="multiMarketPin"
          className="add-pin"
          style={{ cursor: "pointer" }}
          title="Add to Multi Markets"
        >
          Pin
        </a>
      </dd>
    </dl>
  );
};

export default SingleEvent;
